import * as action from '../lib/BLL';

export const getCampaignContent = (params, callback) => {
  return (dispatch, getState) => {
    action.getCampaignContent(params, json => {
      callback(json);
    });
  };
};

export const getCampaignTitle = (params, callback) => {
  return (dispatch, getState) => {
    action.getCampaignTitle(params, json => {
      callback(json);
    });
  };
};


// WEBPACK FOOTER //
// ./common/actions/campaign.js